import styled from '@emotion/styled'
import * as React from 'react'

type CheckboxWithLabelProps = {
  checked?: boolean
  children?: React.ReactNode
  'data-testid'?: string
  onChange?: (value: boolean) => void
}

const StyledLabelContainer = styled.label`
  vertical-align: middle;
  align-items: center;
  display: block;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:hover input ~ .checkmark {
    background-color: var(--White80);
  }
  input:checked ~ .checkmark {
    background-color: var(--Red-Dark);
    &:after {
      content: '';
      position: absolute;
      display: none;
    }
  }
  input:checked ~ .checkmark {
    &:after {
      display: block;
      left: 5px;
      top: 2px;
      width: 3.5px;
      height: 6.5px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
`

const StyledCheckboxInput = styled.input`
  vertical-align: middle;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

const StyledCheckboxSpan = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: var(--White90);
  border-radius: 2px;
`

export const CheckboxWithLabel = ({
  checked,
  children,
  onChange,
  ...props
}: CheckboxWithLabelProps) => (
  <StyledLabelContainer>
    <StyledCheckboxInput
      checked={checked}
      data-testid={props['data-testid']}
      type="checkbox"
      onChange={e => onChange && onChange(e.target.checked)}
    />
    <StyledCheckboxSpan className="checkmark" />
    {children}
  </StyledLabelContainer>
)
